import { render, staticRenderFns } from "./RequestPagesPage.vue?vue&type=template&id=532cdf84"
import script from "./RequestPagesPage.vue?vue&type=script&lang=ts"
export * from "./RequestPagesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports